import React, {Component} from 'react';
import {Card, Table} from 'antd';
import {reqGetOutstandingBalanceReport} from '../../api';
import {Link} from 'react-router-dom';
import LinkButton from '../../components/LinkButton';
import {daysDifference} from '../../utils/utility';
import {CSVLink} from 'react-csv';
import moment from 'moment';


export default class OutstandingBalanceReport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      reports: [],
      downloadReport: [],
    };

    //initialize table columns
    this.initColumns();
  }

  componentDidMount() {
    this.setState({loading: true});
    reqGetOutstandingBalanceReport()
      .then(response => {
        const reports = response.data;

        //generate download report
        let downloadReport = reports.map(item => ({
          order_id: item.order_id,
          customer: item.customer,
          job_description: item.job_description,
          order_date: item.order_date,
          payment_time: item.payment_time,
          sales_name: item.sales_name,
          retail_with_taxes: item.retail_with_taxes,
          amount_paid: item.amount_paid,
          outstanding_balance: item.outstanding_balance,
          paid_percentage: item.paid_percentage && (item.paid_percentage + "%"),
          order_need_to_pay: item.order_need_to_pay && (item.order_need_to_pay + "%"),
          need_to_pay: (item.paid_percentage < item.order_need_to_pay) ? "Yes" : "",
          day_diff: daysDifference(item.order_date),
          style_number_description: item.style_number_description,
          requires_approval_cad: item.requires_approval_cad,
          approved_cad: item.approved_cad,
          requires_approval_resin: item.requires_approval_resin,
          approved_resin: item.approved_resin
        }));
        this.setState({loading: false, reports, downloadReport});
      }).catch(error => {
      console.log(error)
    });
  }

  //initial table columns
  initColumns = () => {
    this.columns = [
      {
        title: 'Customer',
        key: 'customer',
        render: (item) =>
          item.customer &&
          <span>
                <Link to={'/orders/edit/' + item.order_id}>
                    <LinkButton>{item.customer}</LinkButton></Link>
            </span>,
      },
      {
        title: 'Job Desc',
        key: 'job_description',
        dataIndex: 'job_description'
      },
      {
        title: 'Order Date',
        key: 'order_date',
        dataIndex: 'order_date'
      },
      {
        title: 'Last Payment',
        key: 'payment_time',
        dataIndex: 'payment_time'
      },
      {
        title: 'Sales',
        key: 'sales_name',
        dataIndex: 'sales_name'
      },
      {
        title: 'Retail',
        key: 'retail_with_taxes',
        dataIndex: 'retail_with_taxes'
      },
      {
        title: 'Amount Paid',
        key: 'amount_paid',
        dataIndex: 'amount_paid'
      },
      {
        title: 'Outstanding Balance',
        key: 'outstanding_balance',
        dataIndex: 'outstanding_balance'
      },
      {
        title: '%Paid',
        key: 'paid_percentage',
        render: (item) => item.paid_percentage && <span>{item.paid_percentage}%</span>
      },
      {
        title: '%Need',
        key: 'order_need_to_pay',
        render: (item) => item.order_need_to_pay && <span>{item.order_need_to_pay}%</span>
      },
      {
        title: 'Day Diff',
        key: 'day_diff',
        render: (item) => (item.paid_percentage < item.order_need_to_pay) ?
          <span style={{color: 'red'}}>{daysDifference(item.order_date)}</span> :
          <span>{daysDifference(item.order_date)}</span>,
      },
      {
        title: 'Style',
        key: 'style_number_description',
        dataIndex: 'style_number_description'
      },
      {
        title: 'Require CAD',
        key: 'requires_approval_cad',
        dataIndex: 'requires_approval_cad'
      },
      {
        title: 'Approve CAD',
        key: 'approved_cad',
        dataIndex: 'approved_cad'
      }, {
        title: 'Require Resin',
        key: 'requires_approval_resin',
        dataIndex: 'requires_approval_resin'
      },
      {
        title: 'Approve Resin',
        key: 'approved_resin',
        dataIndex: 'approved_resin'
      },
    ];
  };

  render() {
    const {reports, downloadReport, loading} = this.state;

    return (

      <Card title='Outstanding Balance Report'>
        <div style={{paddingBottom: '25px'}}>
          <CSVLink
            data={downloadReport}
            filename={moment().format('YYYY-MM-DD-') + "outstanding-balance.csv"}
          >
            Download Outstanding Balance
          </CSVLink>
        </div>

        <Table
          rowKey="order_item_id"
          loading={loading}
          dataSource={reports}
          columns={this.columns}
          pagination={false}
          size="small"
          bordered
          scroll={{x: 'max-content'}}
        />
      </Card>
    );
  }

}